export default {
  getCurrentStatus: state => state.current_status,
  getOldStatus: state => state.old_status,
  getCurrentSurveys: state => state.current_surveys,
  getCurrentEvaluations: state => state.current_evaluations,
  getCurrentSelectSurvey: state => state.current_select_survey,
  getCurrentSelectEvaluation: state => state.current_select_evaluation,
  getCurrentSelectTrainee: state => state.current_select_trainee
}
